import { combineValidators, required, isEmail, isPhone, maxLength } from "../Validators";

export const ContactFormScheme = {
  email: combineValidators(required, isEmail),
  phone: combineValidators(required, isPhone),
  firstName: required,
  lastName: required,
  message: combineValidators(required, maxLength(500)),
};